export const pictures = [
  {
    id: 0,
    name: 'kominiarz na dachu',
    thumbUrl: 'https://i.ibb.co/SVcRCJP/1thumb.webp',
    url: 'https://i.ibb.co/FsW4Ztz/1.webp'
  },
  {
    id: 1,
    name: 'kominiarz na dachu',
    thumbUrl: 'https://i.ibb.co/WPWFtXN/2thumb.webp',
    url: 'https://i.ibb.co/MDZKKdL/2.webp'
  },
  {
    id: 2,
    name: 'kominiarz na dachu',
    thumbUrl: 'https://i.ibb.co/G070VtT/3thumb.webp',
    url: 'https://i.ibb.co/Db9sy1v/3.webp'
  },
  {
    id: 3,
    name: 'kominiarz na dachu',
    thumbUrl: 'https://i.ibb.co/YbFWvBC/4thumb.webp',
    url: 'https://i.ibb.co/gFRzqS0/4.webp'
  },
  {
    id: 4,
    name: 'kominiarz na dachu',
    thumbUrl: 'https://i.ibb.co/6FyPyYQ/5thumb.webp',
    url: 'https://i.ibb.co/3cd0Y0W/5.webp'
  },
  {
    id: 5,
    name: 'kominiarz na dachu',
    thumbUrl: 'https://i.ibb.co/tbxQjFf/6thumb.webp',
    url: 'https://i.ibb.co/BVSppZt/6.webp'
  },
  {
    id: 6,
    name: 'kominiarz na dachu',
    thumbUrl: 'https://i.ibb.co/CVmS6Rc/7thumb.webp',
    url: 'https://i.ibb.co/sKrgqJn/7.webp'
  },
  {
    id: 7,
    name: 'kominiarz na dachu',
    thumbUrl: 'https://i.ibb.co/23Wx3CW/8thumb.webp',
    url: 'https://i.ibb.co/FsVk8qH/8.webp'
  }
]
